<BaseModal
  v-model="isOpen"
  class="shipping-info-modal"
  :bottom-sheet-on-mobile="true"
  :show-close-button="true"
  width="760px"
>
  <template #header>
    {{ $t('footer_menu.customer_service.delivery_cost') }}
  </template>
  <div class="shipping-info-content">
    <div class="pp-in wait" v-if="loading"></div>
    <div v-else-if="error" class="shipping-info-error">{{ error }}</div>
    <div v-else-if="contentHtml" class="shipping-info-body" v-html="contentHtml" />
  </div>
  <template #footer>
    <button type="button" class="checkout-v2-btn shipping-info-modal__close-btn" @click="isOpen = false">
      {{ $t('actions.close') || 'Close' }}
    </button>
  </template>
</BaseModal>
